module.exports = __webpack_public_path__ + "img/数据更新优势@2x.a8d3a87e.png";